import Twig from "twig";

export function getTwigTemplate(path, callback) {
  return Twig.twig({
    href: window.wordpress.theme_uri + "/app/templates/" + path,
    // for this example we'll block until the template is loaded
    async: true,

    // The default is to load asynchronously, and call the load function
    //   when the template is loaded.

    load: function (template) {
      console.log("template loaded");
      callback(template);
    },
  });
}

export function loadTwigExtensions() {
  Twig.extendFilter("svg", (value) => {
    let contents = "";

    $.ajax(window.wordpress.theme_uri + "/dist/images/" + value + ".svg", {
      async: false,
      dataType: "html",
      success: (data) => {
        contents = data;
      },
    });

    return contents;
  });
}



// WEBPACK FOOTER //
// ./scripts/lib/twig/twig.js